import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import { RoughRenderer } from './renderer';
var hasDocument = typeof document !== 'undefined';
export var RoughSVGBase =
/*#__PURE__*/
function () {
  function RoughSVGBase(svg) {
    _classCallCheck(this, RoughSVGBase);

    this.svg = svg;
  }

  _createClass(RoughSVGBase, [{
    key: "draw",
    value: function draw(drawable) {
      var sets = drawable.sets || [];
      var o = drawable.options || this.getDefaultOptions();
      var doc = this.svg.ownerDocument || hasDocument && document;
      var g = doc.createElementNS('http://www.w3.org/2000/svg', 'g');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = sets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var drawing = _step.value;
          var path = null;

          switch (drawing.type) {
            case 'path':
              {
                path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', this.opsToPath(drawing));
                path.style.stroke = o.stroke;
                path.style.strokeWidth = o.strokeWidth + '';
                path.style.fill = 'none';
                break;
              }

            case 'fillPath':
              {
                path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', this.opsToPath(drawing));
                path.style.stroke = 'none';
                path.style.strokeWidth = '0';
                path.style.fill = o.fill || null;
                break;
              }

            case 'fillSketch':
              {
                path = this.fillSketch(doc, drawing, o);
                break;
              }

            case 'path2Dfill':
              {
                path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', drawing.path || '');
                path.style.stroke = 'none';
                path.style.strokeWidth = '0';
                path.style.fill = o.fill || null;
                break;
              }

            case 'path2Dpattern':
              {
                if (!this.defs) {
                  console.error('Cannot render path2Dpattern. No defs/document defined.');
                } else {
                  var size = drawing.size;
                  var pattern = doc.createElementNS('http://www.w3.org/2000/svg', 'pattern');
                  var id = "rough-".concat(Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER || 999999)));
                  pattern.setAttribute('id', id);
                  pattern.setAttribute('x', '0');
                  pattern.setAttribute('y', '0');
                  pattern.setAttribute('width', '1');
                  pattern.setAttribute('height', '1');
                  pattern.setAttribute('height', '1');
                  pattern.setAttribute('viewBox', "0 0 ".concat(Math.round(size[0]), " ").concat(Math.round(size[1])));
                  pattern.setAttribute('patternUnits', 'objectBoundingBox');
                  var patternPath = this.fillSketch(doc, drawing, o);
                  pattern.appendChild(patternPath);
                  this.defs.appendChild(pattern);
                  path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
                  path.setAttribute('d', drawing.path || '');
                  path.style.stroke = 'none';
                  path.style.strokeWidth = '0';
                  path.style.fill = "url(#".concat(id, ")");
                }

                break;
              }
          }

          if (path) {
            g.appendChild(path);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return g;
    }
  }, {
    key: "fillSketch",
    value: function fillSketch(doc, drawing, o) {
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      var path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', this.opsToPath(drawing));
      path.style.stroke = o.fill || null;
      path.style.strokeWidth = fweight + '';
      path.style.fill = 'none';
      return path;
    }
  }, {
    key: "defs",
    get: function get() {
      var doc = this.svg.ownerDocument || hasDocument && document;

      if (doc) {
        if (!this._defs) {
          var dnode = doc.createElementNS('http://www.w3.org/2000/svg', 'defs');

          if (this.svg.firstChild) {
            this.svg.insertBefore(dnode, this.svg.firstChild);
          } else {
            this.svg.appendChild(dnode);
          }

          this._defs = dnode;
        }
      }

      return this._defs || null;
    }
  }], [{
    key: "createRenderer",
    value: function createRenderer() {
      return new RoughRenderer();
    }
  }]);

  return RoughSVGBase;
}();